export class Coordinates{
    latitude : number;
    longitude : number;
    altitude : number;
}

export class GeocodeRequest{
    Address : string;
    City : string;
    State: string;
    CountryCode : string;
    PostalCode : string;
    excludePostCode : boolean;
}

//reverse geoCode
export class ReverseGeocode
{
    plus_code: PlusCode;
    results: Result[];
    status: string;
}

export class AddressComponent
{
    long_name: string;
    short_name: string;
    types: string[];
}

export class Bounds
{
northeast: Northeast;
southwest: Southwest;
}

export class Geometry
{
    location: Location;
    location_type: string;
    viewport: Viewport;
    bounds: Bounds;
}

export class Location
{
    lat: number;
    lng: number;
}

export class Northeast
{
    lat: number;
    lng: number;
}

export class PlusCode
{
    compound_code: string;
    global_code: string;
}

export class Result
{
    address_components: AddressComponent[];
    formatted_address: string;
    geometry: Geometry;
    place_id: string;
    plus_code: PlusCode;
    types: string[];
}

export class Southwest
{
    lat: number;
    lng: number;
}

export class Viewport
{
   northeast: Northeast;
    southwest: Southwest;
}

